module.exports = __webpack_public_path__ + "img/jdLogo.79eef833.png";